import React, { Component } from 'react';

import './styles.css';

/**
 * Description
 *
 * @typedef {Object} Props
 * @prop {number} count
 * @prop {number} index
 * @prop {Function} [onChange]
 *
 * @augments {Component<Props>}
 */
export default class SlidePagination extends Component {

	genPagination = (item, index) => (
		<label key={index}>
			<input
				checked={index === this.props.index}
				name='pagination'
				onChange={this.handleChange}
				type='radio'
				value={index}
			/>
			<span />
		</label>
	);

	handleChange = (event) => this.props.onChange && this.props.onChange(+event.target.value);

	render () {
		return (
			<form className='SlidePagination'>
				{Array(this.props.count).fill('').map(this.genPagination)}
			</form>
		);
	}

}



// WEBPACK FOOTER //
// ./src/components/atoms/SlidePagination/SlidePagination.js